import { adt, eq, iots, nat } from '@code-expert/prelude';

const BinaryQuizGradingSettings = iots.strict({
  xpMode: iots.literal('binary'),
  minimumPoints: iots.Nat,
});

export type BinaryQuizGradingSettings = iots.TypeOf<typeof BinaryQuizGradingSettings>;

const ProportionalQuizGradingSettings = iots.strict({
  xpMode: iots.literal('proportional'),
});

export type ProportionalQuizGradingSettings = iots.TypeOf<typeof ProportionalQuizGradingSettings>;

export const QuizGradingSettings = iots.union([
  BinaryQuizGradingSettings,
  ProportionalQuizGradingSettings,
]);

export type QuizGradingSettings = iots.TypeOf<typeof QuizGradingSettings>;

export const eqQuizGradingSettings: eq.Eq<QuizGradingSettings> = adt.getEq('xpMode', {
  binary: eq.strict({ minimumPoints: nat.Eq }),
  proportional: eq.trivial,
});

export const foldQuizGradingSettings = adt.foldFromTags<QuizGradingSettings, 'xpMode'>('xpMode');
